import { render, staticRenderFns } from "./UserSuspendModal.vue?vue&type=template&id=71740148&"
import script from "./UserSuspendModal.vue?vue&type=script&lang=js&"
export * from "./UserSuspendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports